import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { applyClasses, applyProps } from '../shared/js';
import styles from './form.module.scss';

const FormSection = ({ id, className, children, ...props }) => (
  <div
    id={id}
    className={cn(styles.formSection, className, applyClasses(props, styles))}
    {...applyProps(props)}
  >
    {children}
  </div>
);

FormSection.propTypes = {
  /** The ID of the section element. Useful to select the section during testing. */
  id: PropTypes.string,
  /** Class name string forwarded to the section element */
  className: PropTypes.string,
  /** Style object forwarded to the section element */
  style: PropTypes.object,
  /** The contents of the section */
  children: PropTypes.any,
};

FormSection.defaultProps = {
  className: undefined,
  style: undefined,
  children: undefined,
};

export default FormSection;
